import React from 'react';

const ActionButton = ({
  children,
  icon: Icon,
  onClick,
  variant = 'primary',
  size = 'md',
  disabled = false,
  loading = false,
  className = '',
  ...props
}) => {
  const getVariantClasses = (variant) => {
    switch (variant) {
      case 'primary': return 'bg-blue-600 hover:bg-blue-700 text-white border-transparent';
      case 'secondary': return 'bg-gray-100 hover:bg-gray-200 text-gray-900 border-gray-300';
      case 'danger': return 'bg-red-600 hover:bg-red-700 text-white border-transparent';
      case 'ghost': return 'hover:bg-gray-50 text-gray-700 border-transparent';
      default: return 'bg-blue-600 hover:bg-blue-700 text-white border-transparent';
    }
  };

  const getSizeClasses = (size) => {
    switch (size) {
      case 'xs': return 'px-2 py-1 text-xs';
      case 'sm': return 'px-3 py-1.5 text-sm';
      case 'md': return 'px-4 py-2 text-sm';
      case 'lg': return 'px-6 py-3 text-base';
      default: return 'px-4 py-2 text-sm';
    }
  };

  const getIconSize = (size) => {
    switch (size) {
      case 'xs': return 'w-3 h-3';
      case 'sm': return 'w-3 h-3';
      case 'md': return 'w-4 h-4';
      case 'lg': return 'w-5 h-5';
      default: return 'w-4 h-4';
    }
  };

  const variantClasses = getVariantClasses(variant);
  const sizeClasses = getSizeClasses(size);
  const iconSizeClasses = getIconSize(size);

  const isDisabled = disabled || loading;

  return (
    <button
      onClick={onClick}
      disabled={isDisabled}
      className={`
        inline-flex items-center justify-center space-x-2
        border rounded-lg font-medium transition-colors
        disabled:opacity-50 disabled:cursor-not-allowed
        ${variantClasses} ${sizeClasses} ${className}
      `}
      {...props}
    >
      {loading ? (
        <div className={`animate-spin rounded-full border-b-2 border-current ${iconSizeClasses}`}></div>
      ) : Icon ? (
        <Icon className={iconSizeClasses} />
      ) : null}
      {children && <span>{children}</span>}
    </button>
  );
};

export default ActionButton;
